<template>
    <div style=" background-color: #ffffff;height: calc(100vh - 84px) ;">
        <div class="flex_box">
            <!-- 搜索框 -->
            <el-form class="demo-form-inline" :inline="true" ref="taskSearchForm" :model="taskSearchForm" size="mini" label-width="120px">
                <el-form-item label="任务类型" prop="taskType"> 
                    <el-select placeholder="请选择任务类型" v-model="taskSearchForm.taskType">
                        <el-option v-for="item in taskTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="作业状态" prop="taskStatus"> 
                    <el-select placeholder="请选择作业状态" v-model="taskSearchForm.taskStatus" clearable>
                        <el-option v-for="item in creationTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item label="提单号" prop="blNo"> 
                        <el-input placeholder="请输入提单号" clearable v-model="taskSearchForm.blNo" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="仓库名称" prop="ckName"> 
                    <el-select placeholder="请选择仓库" v-model="taskSearchForm.ckName" clearable>
                        <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="委托单位" prop="customer"> 
                    <el-select filterable placeholder="请选择委托单位" v-model="taskSearchForm.customer" clearable>
                        <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="司机" prop="driver"> 
                    <el-input placeholder="请输入司机" clearable v-model="taskSearchForm.driver" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="车牌号" prop="truckNo"> 
                    <el-input placeholder="请输入车牌号" clearable v-model="taskSearchForm.truckNo" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="计划创建日期" prop="planDate"> 
                    <el-date-picker v-model="planDate" clearable value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    @change="getPlanDate"> </el-date-picker>
                </el-form-item>
                <el-form-item > 
                    <el-button size="mini" @click="taskListSeacher" type="primary" plain>搜索</el-button>
                    <el-button size="mini" @click="clearSeacher"  plain>清空</el-button>
                </el-form-item>
            </el-form>
            <div style="flex: 1;">
                <vxe-table id="taskTable"  size="mini" ref="taskTable" :data="taskList" border stripe
                    :column-config="{resizable: true,sortable: true}"  header-align="center" :row-config="{ isHover: true}" 
                    :radio-config="{labelField: '', highlight: true}" style="margin-top: 0px;" min-height="0" height="100%" >
                        <!-- 列渲染 -->
                        <!-- <vxe-column type="checkbox" fixed="left" width="50"></vxe-column> -->
                        <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                        <vxe-column field="taskNo" title="作业单号" min-width="140" fixed="left">
                            <template #default="{ row } ">
                                <span v-if="row.rowStatus === '完成'" @click="getCompleteDetails(row)">
                                    <el-link  type="primary"  style="font-size: 12px;">{{row.taskNo}}</el-link>
                                </span>
                                <span v-else> {{ row.taskNo }} </span>
                            </template>
                        </vxe-column>
                        <vxe-column field="rowStatus" title="状态" fixed="left" sortable width="70"></vxe-column>
                        <vxe-column field="isBonded" title="保税类型" sortable width="90"></vxe-column>
                        <vxe-column field="goodsName" title="货物名称"  min-width="120"></vxe-column>
                        <vxe-column field="ownerName" title="货主单位" min-width="180"></vxe-column>
                        <vxe-column field="blNo" title="提单号" min-width="120"></vxe-column>
                        <vxe-column field="cusDeclNo" title="报关单号" min-width="140"></vxe-column>
                        <vxe-column field="boxNo" title="箱号" min-width="120"></vxe-column>
                        <vxe-column field="sealNo" title="铅封号" min-width="120"></vxe-column>
                        <vxe-column field="qty1" title="总件数1" min-width="80"></vxe-column>
                        <vxe-column field="netWeight" title="总净重(KG)" width="90"></vxe-column>
                        <vxe-column field="ckName" title="仓库" min-width="90"></vxe-column>
                        <vxe-column field="driver" title="司机" min-width="60"></vxe-column>
                        <vxe-column field="truckNo" title="车牌" min-width="80"></vxe-column>
                        <vxe-column field="storekeeper" title="理货员"  min-width="70"></vxe-column>
                        <vxe-column field="createDate" title="创建时间" sortable  width="100"  ></vxe-column>
                        <vxe-column field="completeDate" title="完成时间" sortable  width="100" ></vxe-column>
                    </vxe-table>
                </div>
            <vxe-pager align="left" :current-page.sync="pagination.currentPage" :page-size.sync="pagination.pageSize" :page-sizes="pageSizes"
                :total="pagination.total" @page-change="wmsGetTasksByConditions" size="mini">
            </vxe-pager>
        </div>
        <!-- 查看完成后的任务信息 -->
        <viewCompletework :viewCompleteworkVisible="viewCompleteworkVisible" :completeworkRow="completeworkRow"
        @viewCompleteworkClose="viewCompleteworkClose"></viewCompletework>
    </div>
</template>
<script>
import viewCompletework from '@/components/wms/viewCompletework.vue'
export default {
    name: 'inAndOutTaskList',
    components:{
        viewCompletework
    },
    watch: { 
        
    },
    data() {
        return{
            taskSearchForm:{
                taskType:'入库作业',// 任务类型
                customer:'', // 客户
                driver:'', // 司机
                truckNo:'', // 车牌号
                createDateEnd:'', // 创建时间结束
                createDateStart:'', // 创建时间开始
                taskStatus:'', // 任务状态
                ckName:'', // 仓库名称
                blNo:'',
            },
            planDate:[], // 创建作业日期数组
            // 任务类型列表
            taskTypeList:[
                {
                    value: '入库作业',
                    label: '入库作业'
                },{
                    value: '出库作业',
                    label: '出库作业'
                }
            ],
            // 任务状态
            creationTypeList:[
                {
                    value: '新建',
                    label: '新建'
                },{
                    value: '作业中',
                    label: '作业中'
                },{
                    value: '完成',
                    label: '完成'
                }
            ],
            // 分页信息
            pagination:{
                totalPages: 0, // 总页数
                total: 0, // 总条数
                currentPage: 1, // 当前页数
                pageSize: 20, // 每页显示多少条数据
            },
            pageSizes:[10,15,20,50,100],
            ckNameList:[],  // 仓库名称列表
            customerList:[], // 委托单位列表
            taskList:[], // 出入库作业列表
            // 查看完成作业弹窗
            viewCompleteworkVisible:false,
            completeworkRow:{}, // 完成的row信息
        }
    },
    created() {
        // 日期默认当天
        // 获取今天日期
        const today = new Date(); 
        const year = today.getFullYear();  
        const month = String(today.getMonth() + 1).padStart(2, '0');  
        const day = String(today.getDate()).padStart(2, '0'); 
        this.taskSearchForm.createDateStart = `${year}-${month}-${day}`;
        this.taskSearchForm.createDateEnd = `${year}-${month}-${day}`;
        this.planDate = [ this.taskSearchForm.createDateStart ,this.taskSearchForm.createDateEnd ]
        this.getckNameList()
        this.getCompanyList()
        this.taskListSeacher()
    },
    mounted() {

    },
    methods: {
        // 获取仓库
        getckNameList(){
            this.$api.getCkNamesBy(  ).then(res =>{
               this.ckNameList = res
            })
        },
        // 获取客户信息
        getCompanyList(){
            this.$api.getCompanyList(  ).then(res =>{
                this.customerList = res.tableData
            })
        },
        // 计划作业日期获取
        getPlanDate(data){
            if(data === null){
                this.taskSearchForm.createDateStart = ''
                this.taskSearchForm.createDateEnd = ''
            }else{
                this.taskSearchForm.createDateStart = data[0]
                this.taskSearchForm.createDateEnd = data[1]
            }
        },
        // 查询出入库作业列表
        taskListSeacher(){
            this.pagination.currentPage = 1
            this.wmsGetTasksByConditions()
        },
        wmsGetTasksByConditions(){
            this.$api.wmsGetTasksByConditions(this.taskSearchForm,this.pagination.pageSize,this.pagination.currentPage ).then(res =>{
                this.taskList = res.records
                this.pagination.total = res.total
                this.pagination.currentPage = res.current
                this.pagination.pageSize = res.size
            })
        },
        // 清空搜索框
        clearSeacher(){
           this.taskSearchForm ={
                taskType:'入库',// 任务类型
                customer:'', // 客户
                driver:'', // 司机
                truckNo:'', // 车牌号
                createDateEnd:'', // 创建时间结束
                createDateStart:'', // 创建时间开始
                taskStatus:'', // 任务状态
                ckName:'', // 仓库名称
                blNo:'', // 提单号
            },
            this.planDate=[] // 创建作业日期数组
        },
         // 查看完成状态下的作业详情
        getCompleteDetails(row){
            // 查详情
            this.$api.wmsGetOpDetailBy(row.id).then(res =>{
                this.completeworkRow.childList = res
            })
            this.viewCompleteworkVisible = true
            this.completeworkRow = row
        },
         // 关闭查看完成状态下的作业详情
        viewCompleteworkClose(){
            this.viewCompleteworkVisible = false
            this.completeworkRow = {}
            // 刷新页面
            this.wmsGetTasksByConditions()
        },
    }
}
</script>
<style style lang="less" scoped>
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
.flex_box{
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
}
</style>